export const instantAllowedTypes = {
  instantAllowed: 'instantAllowed',
  instantNotAllowed: 'instantNotAllowed',
}
